import {
  LOG_OUT,
  GET_VENDOR_USERS_TICKETS,
  GET_VENDOR_DINER_MOBILE,
  GET_VENDOR_DINER_ISSUES_CATEGORY,
  GET_SINGLE_VENDOR_USERS_TICKETS,
  EDIT_VENDOR_USER_TICKETS_DETAILS,
  GET_ISSUE_SEATING_ADD_TICKET,
  GET_ISSUE_ORDERS_ADD_TICKET,
  GET_ISSUE_OFFERS_ADD_TICKET,
  GET_ISSUE_SCANPAY_ADD_TICKET,
  GET_ISSUE_EVENT_ADD_TICKET,
  GET_ISSUE_WALLET_ADD_TICKET,
  GET_ISSUE_RATINGREVIEW_ADD_TICKET,
  GET_VENDOR_ORDER_ITEM_LIST,
} from "../../types";

const initialState = {
  vendor_all_users_tickets: [],
  vendor_get_single_user_ticket: {},
  edit_vendor_user_tickets: {},
  vendor_get_diner_mobile: [],
  vendor_get_issues_category: [],
  user_seating_issue_ticket: [],
  user_orders_issue_ticket: [],
  user_offers_issue_ticket: [],
  user_scanpay_issue_ticket: [],
  user_event_issue_ticket: [],
  user_wallet_issue_ticket: [],
  user_ratingreview_issue_ticket: [],
  get_order_item_list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_VENDOR_USERS_TICKETS:
      return {
        ...state,
        vendor_all_users_tickets: action.payload,
      };
    case GET_SINGLE_VENDOR_USERS_TICKETS:
      return {
        ...state,
        vendor_get_single_user_ticket: action.payload,
      };
    case GET_VENDOR_DINER_MOBILE:
      return {
        ...state,
        vendor_get_diner_mobile: action.payload,
      };
    case GET_ISSUE_SEATING_ADD_TICKET:
      return {
        ...state,
        user_seating_issue_ticket: action.payload,
      };
    case GET_ISSUE_ORDERS_ADD_TICKET:
      return {
        ...state,
        user_orders_issue_ticket: action.payload,
      };
    case GET_ISSUE_OFFERS_ADD_TICKET:
      return {
        ...state,
        user_offers_issue_ticket: action.payload,
      };
    case GET_ISSUE_SCANPAY_ADD_TICKET:
      return {
        ...state,
        user_scanpay_issue_ticket: action.payload,
      };
    case GET_ISSUE_EVENT_ADD_TICKET:
      return {
        ...state,
        user_event_issue_ticket: action.payload,
      };
    case GET_ISSUE_WALLET_ADD_TICKET:
      return {
        ...state,
        user_wallet_issue_ticket: action.payload,
      };
    case GET_ISSUE_RATINGREVIEW_ADD_TICKET:
      return {
        ...state,
        user_ratingreview_issue_ticket: action.payload,
      };
    case GET_VENDOR_DINER_ISSUES_CATEGORY:
      return {
        ...state,
        vendor_get_issues_category: action.payload,
      };
    case EDIT_VENDOR_USER_TICKETS_DETAILS:
      return {
        ...state,
        edit_vendor_user_tickets: action.payload,
      };
    case LOG_OUT: {
      return {
        ...state,
        vendor_all_users_tickets: [],
      };
    }
    case GET_VENDOR_ORDER_ITEM_LIST:
      return {
        ...state,
        get_order_item_list: action.payload,
      };
    default:
      return state;
  }
}
